import React from "react";

const Working = () => {
  return (
    <div className="mt-14">
      <h1 className="text-3xl text-center font-bold">Page Under Working ...</h1>
    </div>
  );
};

export default Working;
